import { RootState } from 'reducers/rootReducer';
import { PayloadAction } from 'types/payloadAction';

// Action Types
const NAME = 'unsavedModal';

const SHOW = `${NAME}/SHOW`;
const HIDE = `${NAME}/HIDE`;
const QUEUE = `${NAME}/QUEUE`;
const UNQUEUE = `${NAME}/UNQUEUE`;

export interface UnsavedModalState {
  readonly isShowing: boolean;
  readonly hasLogoutQueued: boolean;
}

// Initial State
const initialState: UnsavedModalState = {
  isShowing: false,
  hasLogoutQueued: false,
};

// Action Creators
export const actions = {
  hide: () => ({ type: HIDE }),
  show: () => ({ type: SHOW }),
  queue: () => ({ type: QUEUE }),
  unqueue: () => ({ type: UNQUEUE }),
};

// Selectors
const isShowing = (rootState: RootState): boolean => rootState.unsavedModal.isShowing;

const isQueued = (rootState: RootState): boolean => rootState.unsavedModal.hasLogoutQueued;

export const selectors = {
  isShowing,
  isQueued,
};

// Reducers
const showReducer = (state: UnsavedModalState): UnsavedModalState => ({
  ...state,
  isShowing: true,
});

const hideReducer = (state: UnsavedModalState): UnsavedModalState => ({
  ...state,
  isShowing: false,
});

const queueReducer = (state: UnsavedModalState): UnsavedModalState => ({
  ...state,
  hasLogoutQueued: true,
});

const unqueueReducer = (state: UnsavedModalState): UnsavedModalState => ({
  ...state,
  hasLogoutQueued: false,
});

export const reducer = (
  state: UnsavedModalState = initialState,
  action: PayloadAction,
): UnsavedModalState => {
  switch (action.type) {
    case HIDE:
      return hideReducer(state);

    case SHOW:
      return showReducer(state);

    case QUEUE:
      return queueReducer(state);

    case UNQUEUE:
      return unqueueReducer(state);

    default:
      return state;
  }
};
